import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { FlaggedExercise } from "src/app/shared/interfaces/flagged-exercises";
import {
  cancelflaggedExerciseFailure,
  cancelflaggedExerciseLoad,
  cancelflaggedExerciseLoadSuccess,
} from "../../actions/flagged-exercises/cancel-flagged-exercise.actions";
import { RequestStatus } from "src/app/shared/interfaces/request-status";

export interface CancelFlaggedExerciseState {
  exercise: FlaggedExercise | null;
  error: HttpErrorResponse | null;
  status: RequestStatus;
}

const initialState: CancelFlaggedExerciseState = {
  exercise: null,
  error: null,
  status: "IDLE",
};

export const cancelFlaggedExerciseReducer = createReducer(
  initialState,
  on(
    cancelflaggedExerciseLoad,
    (state): CancelFlaggedExerciseState => ({
      ...state,
      exercise: null,
      error: null,
      status: "PENDING",
    }),
  ),
  on(
    cancelflaggedExerciseLoadSuccess,
    (state, action): CancelFlaggedExerciseState => ({
      ...state,
      exercise: action.exercise,
      error: null,
      status: "SUCCESS",
    }),
  ),
  on(cancelflaggedExerciseFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: "FAILED",
  })),
);
